import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router';
import { Button } from '@hostfully/ui-components';
import { appUrlParamName } from './ResetPassword.constants';
import {
  PublicFormButtonContainer,
  PublicFormSubtitle,
  PublicFormTitle,
} from '@/pages/_layouts/publicLayout/publicForm.styles';
import { Location } from '@/utils/windowsUtils';

const ResetSuccessSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const appUrl = searchParams.get(appUrlParamName);

  const handleSignInClick = () => {
    if (appUrl) {
      Location.change(appUrl);
      return;
    }
    navigate('/login');
  };

  return (
    <div data-testid="reset-success">
      <PublicFormTitle data-testid="reset-success-title">
        {t('pageForgotPassword.successTitle')}
      </PublicFormTitle>
      <PublicFormSubtitle data-testid="reset-success-subtitle">
        {t('pageForgotPassword.successSubtitle')}
      </PublicFormSubtitle>
      <PublicFormButtonContainer>
        <Button
          data-testid="reset-success-sign-in"
          size="large"
          onClick={handleSignInClick}
        >
          {t('pageForgotPassword.signIn')}
        </Button>
      </PublicFormButtonContainer>
    </div>
  );
};

export default ResetSuccessSection;
